/**
 * @fileoverview Layout uniforme para todas las pantallas: container
 * centrado con max-width, encabezado de marca discreto, fondo neutral.
 */

import { motion } from "framer-motion";

/**
 * @param {{
 *   children: React.ReactNode,
 *   showBrand?: boolean,
 *   testid?: string,
 * }} props
 */
export function AppShell({ children, showBrand = true, testid }) {
    return (
        <div
            className="min-h-screen bg-background text-foreground"
            data-testid={testid || "app-shell"}
        >
            {showBrand ? (
                <header className="border-b border-border/60 bg-card/40 backdrop-blur-sm">
                    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-3">
                        <p className="text-xs uppercase tracking-[0.18em] text-primary font-semibold">
                            Congreso de la Ciudad de México
                        </p>
                    </div>
                </header>
            ) : null}

            <motion.main
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.25 }}
                className="max-w-2xl mx-auto px-4 sm:px-6 py-8 sm:py-12"
            >
                {children}
            </motion.main>

            <footer className="max-w-2xl mx-auto px-4 sm:px-6 py-6 text-center text-xs text-muted-foreground/70">
                Rumbo a la Nueva Ley de Participación Ciudadana &middot; Tu participación es anónima.
            </footer>
        </div>
    );
}
